import React from "react";
import { Card, CardContent, CardActions } from "@mui/material";
import { CustomCardHeader } from "./CustomCardHeader";
import "./CustomCard.css";

export interface CustomCardProps {
  cardMedia?: boolean;
  cardHeader?: boolean;
  cardFooter?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const CustomCard = ({
  cardMedia,
  cardHeader,
  cardFooter,
  children,
  className,
}: CustomCardProps) => {
  const mediaClassName = cardMedia ? " custom-card--media" : "";
  const cardClassName = className
    ? `custom-card${mediaClassName} ${className}`
    : `custom-card${mediaClassName}`;

  return (
    <Card className={cardClassName}>
      {cardHeader && <CustomCardHeader title="Card Title" />}
      <CardContent className="custom-card-content">
        {children}
      </CardContent>
      {cardFooter && <CardActions className="custom-card-actions">Footer Actions</CardActions>}
    </Card>
  );
};